import { createFileRoute } from '@tanstack/react-router';
import { AreaAcl } from '@/components/Admin/AreaAcl/AreaAcl';

export const Route = createFileRoute('/_adminLayout/admin/areas/$areaSlug/acl')({
  component: RouteComponent,
});

function RouteComponent() {
  const { areaSlug } = Route.useParams();
  return <AreaAcl areaSlug={areaSlug} />;
}
